import React, { Fragment, useState, useEffect } from 'react'
import "./post.css";
import { MoreVert, MoreHoriz } from "@material-ui/icons";
import { faSmile, faThumbsUp, faTrash, faEllipsisV, faEllipsisH } from '@fortawesome/free-solid-svg-icons'
import ViewCommunityItemBtn from './../../../ViewCommunityItemButton';
import EditPostButton from './../../../EditPostButton';
import EditCommentButton from './../../../EditCommentButton';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { COLORS } from '../../../../styles/colors';
import { ConfirmJsMessage } from '../../../../helpers.js'
import Moment from "react-moment"
import ReactImageFallback from "react-image-fallback";
import { getName, getAvtar }  from "./../utils"
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import CommentForm from "../share/CommentForm";
import Comment from "./Comment"
import { deleteItem } from '../../../../store/actions/community';


export default function Post(props) {

  const { isMobile, item, create, user, postIndex } = props;
  const [isLiked, setIsLiked] = useState(false)
  const [anchorEl, setAnchorEl] = useState(null);
  const [anchorCommentEl, setAnchorCommentEl] = useState(null);
  const [isViewComment, setIsViewComment ] = useState(false);
  const [comments, setComments ] = useState([]);
  const [selectedComment, setSelectedComment] = useState({})
  const [totalComments, setTotalComments] = useState(0);
  const [totalLikes, setTotalLikes] = useState(0);
  const [isOpenCommentModal, setCommentModal] = useState(false);

  useEffect(() => {
    if (user && user.favouritePosts) {
      const findIndex =  user.favouritePosts.findIndex((post) => post.id === item._id);
      if (findIndex > -1) {
        setIsLiked(true)
      }
    }
    if(item.comments && item.comments.length) {
      setComments(item.comments[0].data);
      setTotalComments(item.comments[0].metadata && item.comments[0].metadata.length > 0 ? item.comments[0].metadata[0]['total'] : 0)
      setTotalLikes(item.totalLikes);
    }
  }, [item._id])
  
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  }

  const handleClose = () => {
    setAnchorEl(null);
  }

  const likeHandler =()=>{
      props.create('post__like', {
        isLiked: !isLiked,
        postId: item._id
      }).then((res) => {
        if (!isLiked) {
          setTotalLikes(totalLikes + 1);
        } else {
          let tl = totalLikes - 1;
          if (tl < 0) {
            tl = 0;
          }
          setTotalLikes(tl);
        }
        setIsLiked(!isLiked)
		  });
  }

  const toggleViewComment = () => {
    setIsViewComment(!isViewComment)
  }

  const deletePost = (id) => {
    handleClose()
		if (ConfirmJsMessage(`All informations related with this post will be lost. Are you sure you want to delete the post? `)) {
			props.deleteItem(id, 'post').then(() => {
          handleClose();
          props.onDeletePost(id, 'delete')
     	});
		}
	}

  const onDeleteComment = (id) => {
    let cloneComments = [...comments]
    const findIndex = cloneComments.findIndex((comment) => comment._id === id);
    if (findIndex > -1) {
      cloneComments.splice(findIndex, 1);
      setComments([...cloneComments])
      let tc = totalComments - 1;
      if (tc < 0) {
        tc = 0;
      }
      setTotalComments(tc);
    }
	}

  
  const pauseAllVideos = (e) => {
    const videos = document.querySelectorAll('video');
    for(var i=0; i< videos.length; i++){
      if(videos[i] !== e.target) {
        videos[i].pause();
      }
    }
  }

  const onSaveComment = (res, isNew) => {
      if(isNew) {
        setComments([
          {
            ...res,
            user: [user]
          },
          ...comments
        ])
        setTotalComments(totalComments + 1);
      } else {
        const _id = res._id;
        const findIndex = comments.findIndex((comment) => comment._id === _id);
        if (findIndex > -1) {
          comments[findIndex] = {
            ...comments[findIndex],
            ...res
          }
          setComments([...comments])
        }
      }

  }

  const renderViewComments = (comments) => {
    return comments.map((comment, index) => {
      if (index > 2) {
        return null;
      }
      return (
        <Comment 
           onDeleteComment={onDeleteComment} 
           onSaveComment={onSaveComment} 
           key={comment._id} 
           comment={comment} 
           deleteItem = { props.deleteItem }
           {...props}>
        </Comment>
      )
    })
  }

  let postClass = 'post';
  if (isMobile) {
    postClass = 'mobile-post';
  }
  return (
    <Fragment>
    {postIndex === 0 && <div className={isMobile ? 'mobileIntroTopDiv' : 'introTopDiv'}>Intro Post</div>}
      <div className={item.isTranscoding ? `${postClass} listItemDisable` : postClass}>
        <div className="postWrapper">
          <div className="postTop">
            <div className="postTopLeft">
              { item.user && item.user.length > 0 &&
                getAvtar(item.user[0])
              }
              <span className="postUsername">
              { item.user && item.user.length > 0 &&
                getName(item.user[0])
              }
              </span>
              <span className="postDate">
                      <Moment className="text-muted"  style={{
                        'fontSize': '10px',
                        'display': 'block',
                        'height': '12px',
                        'marginTop': '4px'
                      }}  format="D MMM YYYY">{item.createdAt}</Moment>
                      { item.isTranscoding &&
                        <em style={{
                        'fontSize': '14px',
                        'color': 'red'
                        }}> (Processing)</em>
                      }
              </span>
            </div>
            <div className="postTopRight">
            <FontAwesomeIcon onClick={handleClick} size={isMobile && "2x" } icon={faEllipsisV} 
                        style={{color: COLORS.black}}/>
              <Menu
                      id="simple-menu"
                      anchorEl={anchorEl}
                      keepMounted
                      open={Boolean(anchorEl)}
                      onClose={handleClose}
              >
                <MenuItem onClick={handleClose}>
                  { (props.user._id === item.creatorId) &&
                    <EditPostButton item={item} isMobile = {isMobile} topic={props.topic} />
                  }
                </MenuItem>
                { ! item.isIntro &&
                  <MenuItem onClick={() => deletePost(item._id)}>
                  <span
                      className="link"
                      style={{float:'right', color: COLORS.red, marginLeft: isMobile && 10}}>
                      <FontAwesomeIcon size={isMobile && "2x" } icon={faTrash} title={'Delete'}
                        style={{marginRight: 5, color: COLORS.red}}/>Delete
                    </span>
                  </MenuItem>
                }
              </Menu>
            </div>
          </div>
          <div className="postCenter">
            <span className="postText">{item.description}</span>
              { (item.url  && !item.isImage) && 
                  <video  src={item.url} width='400' onPlay={(e) => {
                    pauseAllVideos(e)
                  }}  className="postImg" controls  controlsList="nodownload" loop />
              }
              { (item.url && item.isImage) && 
                <ReactImageFallback 
                  src={item.url} 
                  fallbackImage={'/assets/img/no-image-icon.png'}
                  className="postImg" />
              }
          </div>
          <div className="postBottom">
            <div className="postBottomLeft">
              <FontAwesomeIcon  icon={faThumbsUp} title={'You Liked'}
                  style={{ marginRight: 5, color: isLiked ? COLORS.orange : COLORS.grey, cursor: 'pointer' }} size={"2x" } onClick={likeHandler} />
              
              { (totalLikes > 0) ?
                <ViewCommunityItemBtn 
                  icon={faThumbsUp} 
                  itemCount = { totalLikes }
                  headerText={'View Likes'} 
                  iconText = {'Likes'}
                  itemType = 'post_like'
                  dataStyle={{'width': isMobile ? '90%' : 550 }} 
                  isMobile = {isMobile}
                  item={item} /> : ''
              }
            </div>
            <div className="postBottomRight">
              <span className="postCommentText" style={{
                  color: COLORS.orange
                }} onClick={toggleViewComment}>{totalComments} Comments</span>
            </div>
          </div>
          
          { isViewComment &&
            <div style={{
                  marginTop: 30
              }}>
              { totalComments > 0 && renderViewComments(comments) }
              { totalComments > 3 &&
                <div className='prevComment' style={{
                  color: COLORS.orange
                }}>
                  <ViewCommunityItemBtn 
                    icon={faThumbsUp} 
                    headerText={'Previous Comments'} 
                    iconText = {'Previous Comments'}
                    itemType = 'comment'
                    dataStyle={{'width': isMobile ? '90%' : 400 }} 
                    item={item}
                    isMobile = {isMobile}
                    onDeleteComment={onDeleteComment}
                    deleteItem = { deleteItem } 
                    onSaveComment={onSaveComment}
                /> 
                </div>
              }
              <CommentForm onSaveComment = {onSaveComment} postId = {item._id} topicId = {item.topicId} {...props} />
            </div>
          }

        </div>
      </div>
    {postIndex === 0 && <div className='introBottomDiv'>&nbsp;</div>}
    </Fragment>
  );
}



// WEBPACK FOOTER //
// ./src/components/social/shared/post/Post.jsx